import axiosApi from '@apis/axiosApi'
import { handleError } from '@utils/commonUtils'
import * as queryString from 'query-string'

const BC = '/bang-luong/bao-cao-luong'
const PL = '/bang-luong/phieu-luong'

// Lấy tổng hợp payslip
export function layTongHopBangLuong(userId: number, querySt?: string) {
  try {
    const query = querySt ? queryString.parse(querySt) : {}
    return axiosApi.get(`${PL}/nhan-vien/${userId}/tong-hop`, {
      params: query || {},
    })
  } catch (err: any) {
    handleError(err)
    throw err
  }
}

// Lấy báo cáo tổng quỹ lương
export function layBaoCaoTongQuyLuong(querySt?: string) {
  try {
    const query = querySt ? queryString.parse(querySt) : {}
    return axiosApi.get(`${BC}/tong-quy-luong`, {
      params: query || {},
    })
  } catch (err: any) {
    handleError(err)
    throw err
  }
}

// Lấy báo cáo biến động thu nhập
export function layBaoCaoBienDongThuNhap(querySt?: string) {
  try {
    const query = querySt ? queryString.parse(querySt) : {}
    return axiosApi.get(`${BC}/bien-dong-thu-nhap`, {
      params: query || {},
    })
  } catch (err: any) {
    handleError(err)
    throw err
  }
}

// Lấy báo cáo chi phí nhân sự
export function layBaoCaoChiPhiNhanSu(querySt?: string) {
  try {
    const query = querySt ? queryString.parse(querySt) : {}
    return axiosApi.get(`${BC}/chi-phi-nhan-su`, {
      params: query || {},
    })
  } catch (err: any) {
    handleError(err)
    throw err
  }
}

// Lấy báo cáo chi tiết bảng lương
export function layBaoCaoChiTietBangLuong(userId: number, querySt?: string) {
  try {
    const query = querySt ? queryString.parse(querySt) : {}
    return axiosApi.get(`${BC}/chi-tiet/${userId}`, {
      params: query || {},
    })
  } catch (err: any) {
    handleError(err)
    throw err
  }
}
